"use client";

import type { JSX } from "react";
import { HttpLink } from "@apollo/client";
import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
} from "@apollo/client-integration-nextjs";

export const gqlEndpoint =
  process.env.NEXT_PUBLIC_GQL_ENDPOINT ||
  (typeof window !== "undefined"
    ? `${window.location.origin}/api/graphql`
    : "");

function makeClient() {
  const httpLink = new HttpLink({
    credentials: "include",
    uri: gqlEndpoint,
    fetchOptions: { cache: "no-store" },
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: httpLink,
  });
}

export const ApolloWrapper = ({
  children,
}: React.PropsWithChildren): JSX.Element => (
  <ApolloNextAppProvider makeClient={makeClient}>
    {children}
  </ApolloNextAppProvider>
);
